import '../styles/Footer.css';
import '../styles/App.css';

// Component for footer-section

const Footer = () => (
    <footer className="footer">
        <div className="contact-links">
            <div className="contact-info">
                <h3>Suomen Palloliitto</h3>
                <p>Urheilukatu 5</p>
                <p>00250 Helsinki</p>
                <p>Puhelin (09) 742151</p>
            </div>

            <div className="links-desktop">
                <a
                className="link-desktop"
                href="https://www.palloliitto.fi/tietosuoja/asiakastietojen-tietosuojaseloste"
                target="_blank"
                rel="noopener noreferrer"
                >
                    Tietosuoja
                </a>

                <a
                className="link-desktop"
                href="https://www.palloliitto.fi/evasteseloste"
                target="_blank"
                rel="noopener noreferrer"
                >
                    Evästeet
                </a>

                <a
                className="link-desktop"
                href="https://www.palloliitto.fi/kayttoehdot-terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                >
                    Sivuston käyttöehdot
                </a>
            </div>
        </div>    

        <div className="buttons">
            <a
                className="footer-button"
                component="a"
                href="https://q.surveypal.com/Palautelomake-lipun-kayttajien-tietojen-tayttamisesta"
                target="_blank"
                rel="noopener noreferrer"
            >
                Anna palautetta lomakkeesta
            </a>

            <a
                className="footer-button"
                component="a"
                href="https://osallistu.palloliitto.fi/maajoukkuekirje"
                target="_blank"
                rel="noopener noreferrer"
            >
                Liity postituslistalle
            </a>

            <a
                className="footer-button"
                component="a"
                href="https://www.palloliitto.fi/liput?utm_source=SPL-lomake&utm_medium=referral-internal&utm_campaign=Lipun-kayttajien-tietojen-tayttaminen"
                target="_blank"
                rel="noopener noreferrer"
            >
                Liput
            </a>

            <a
                className="footer-button"
                component="a"
                href="https://kauppa.palloliitto.fi/?utm_source=SPL-lomake&utm_medium=referral-internal&utm_campaign=Lipun-kayttajien-tietojen-tayttaminen"
                target="_blank"
                rel="noopener noreferrer"
            >
                Fanituotteet
            </a>

            <a
            className="footer-button"
            component="a"
            href="https://www.palloliitto.fi/"
            target="_blank"
            rel="noopener noreferrer"
            >
                Palloliitto.fi -pääsivustolle
            </a>
        </div>

        <div className="links-mobile">
            <a
            className="link-mobile"
            href="https://www.palloliitto.fi/tietosuoja/asiakastietojen-tietosuojaseloste"
            target="_blank"
            rel="noopener noreferrer"
            >
                Tietosuoja
            </a>

            <a
            className="link-mobile"
            href="https://www.palloliitto.fi/evasteseloste"
            target="_blank"
            rel="noopener noreferrer"
            >
                Evästeet
            </a>

            <a
            className="link-mobile"
            href="https://www.palloliitto.fi/kayttoehdot-terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            >
                Sivuston käyttöehdot
            </a>

        </div>
    </footer>
)

export default Footer;